<template>
  <div class="notifications-container">
    <span>{{ notification.title }}</span>
    <span>{{ notification.body }}</span>
    <span class="time">{{ dateFromNow(notification.createdAt) }}</span>
  </div>
</template>

<script>
import datetime from "@/utils/datetime";

export default {
  name: 'NotificationsMenu',

  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  methods: {
    ...datetime
  }
}
</script>

<style lang="scss">
.notifications-container {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  width: 100%;
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &.time {
      font-weight: 400;
      font-size: 12px;
      color: #AA9E9E;
    }
  }
}
</style>